import CustomModal from '../../modals';
import { ProspectObject } from '../../../params/prospect';
import { Box, Button, Typography } from '@mui/material';

const ViewProspectsModal = ({ open, onClose, onView, selectedProspect }: { open: boolean; onClose: () => void, onView: () => void, selectedProspect: ProspectObject }) => {
    return (
        <CustomModal open={open} handleClose={onClose} isWhite={true} title="PROSPECTING">
            <Typography
                variant="subtitle2"
                color="textSecondary"
                align="center"
                mb={2}
            >
                Your prospect search for &quot;{selectedProspect?.niche}&quot; is ready.
                Click the button below to display your available prospects. To visit your search history, press the &quot;more options&quot; tab.
            </Typography>
            <Box display="flex" gap={2} mt={1}>
                <Button variant="outlined" fullWidth onClick={onClose}>
                    Cancel
                </Button>
                <Button variant="contained" fullWidth onClick={onView}>
                    View Prospects
                </Button>
            </Box>
        </CustomModal>);
};

export default ViewProspectsModal;